import { VALID_FILTER_FOR_SUMMARY } from "modules/category/constants/filter-constants";
import qs from "query-string";
import PASentry from "util/pa-sentry";
import { INVALID_BROWSER_QUERY_PARAMS } from "../../modules/category/constants/constants";
import { omit } from "../lodash/omit";
import { getNextQuery } from "./getNextQuery";
import { URL_PARAM_ORDERS } from "./urlHelper";

interface IRoutingParams {
  queryString?: string;
  query?: {[key: string]: string};
  href?: string;
  asPath: string;
}

// appendSelectedVehicle is required bcz this method is alos used on server side
// Bug:
// 1. Go to https://partsavatar.ca/ford-focus-brake-components?year=2010
// 2. Select Brake Rotors from category tree & go to tier2
// 3. From popular makes in toolbar, select another vehicle
// 4. then, click browser back button
// Expected behaviour: New vehicle should be selected & it should go to previous page
export function getHrefAndPath(routingParams: IRoutingParams, appendSelectedVehicle = false, clearFilters = false) {
  const {
    queryString = "", query, href = "/[pathname]", asPath,
  } = routingParams;

  const parsedQuery = queryString ? qs.parse(queryString) : query;
  // router.query also has selected vehicle & fitment options. Remove them
  const asPathQuery = getAsPathQueryObj(parsedQuery);
  const hrefQuery = queryString ? qs.parse(queryString) : { ...query };

  if (clearFilters) {
    Object.keys(asPathQuery).forEach((key) => {
      if (VALID_FILTER_FOR_SUMMARY.includes(key)) {
        delete asPathQuery[key];
      }
    });
    Object.keys(hrefQuery).forEach((key) => {
      if (VALID_FILTER_FOR_SUMMARY.includes(key)) {
        delete hrefQuery[key];
      }
    });
  }

  const asPathQueryStr = qs.stringify(asPathQuery, {
    sort: (a: any, b: any) => URL_PARAM_ORDERS.indexOf(a) - URL_PARAM_ORDERS.indexOf(b),
  });
  const hrefQueryStr = qs.stringify(hrefQuery, {
    sort: (a: any, b: any) => URL_PARAM_ORDERS.indexOf(a) - URL_PARAM_ORDERS.indexOf(b),
  });

  const nextQuery = getNextQuery(appendSelectedVehicle ? hrefQueryStr : asPathQueryStr);

  const cleanAsPath = asPath?.indexOf("/") === 0 ? asPath : `/${asPath}`;
  const cleanHref = href.split("?")[0];
  if (!cleanAsPath || cleanAsPath === "undefined") {
    PASentry.logException(new Error("aspath is undefined"), null, {
      cleanHref, cleanAsPath, nextQuery, hrefAndPath: true, hrefAndPathType: typeof cleanAsPath,
    });
  }
  return {
    href: nextQuery.length ? `${cleanHref}?${nextQuery}` : cleanHref,
    asPath: asPathQueryStr.length ? `${cleanAsPath}?${asPathQueryStr}` : cleanAsPath,
  };
}

export function getAsPathQueryObj(queryObj: {[key: string]: string}) {
  if (queryObj && Object.keys(queryObj).length > 0) {
    return omit(queryObj, INVALID_BROWSER_QUERY_PARAMS);
  }

  return {};
}
